import Vue from "vue";
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDZyBrGgnBlnFhv2FNNwpYKdEUVP1G0k3s",
    libraries: "places",
  },
});
